export function focusScanner(vm, refName = "searchInput") {
  if (!vm || vm._isDestroyed) return;
  const blocked =
    vm.showPayment ||
    vm.showReceipt ||
    vm.showQuickCustomer ||
    vm.showHoldModal ||
    vm.showHeldPanel ||
    vm.showMiscModal ||
    vm.showSplitPay;
  if (blocked) return;

  vm.$nextTick(() => {
    const el = vm.$refs[refName];
    if (el && typeof el.focus === "function") {
      el.focus();
      el.select?.();
    }
  });
}

export function shouldRefocusAfterModal(hiddenModal, vm) {
  return !(
    vm.showPayment ||
    vm.showReceipt ||
    vm.showQuickCustomer ||
    vm.showHoldModal ||
    vm.showHeldPanel ||
    vm.showMiscModal ||
    vm.showSplitPay
  );
}
